<script lang="ts">
  import { fly } from "svelte/transition";
  import { createSubscription } from "../../helpers/subscriptions-api";
  import Intro from "./Intro.svelte";
  import Trial from "./Trial.svelte";
  import CloseIcon from "../../components/icons/CloseIcon.svelte";
  import { useQueryClient } from "@tanstack/svelte-query";
  import { subscriptionKeys } from "../../queries/subscriptions";
  import { track } from "../../helpers/mixpanel";
  import { selectedBuyer } from "../../stores/buyer";

  const DEFAULT_PLAN = "premium";
  const DEFAULT_RETURN_URL = `${location.origin}/#/spend-report?subscription=${DEFAULT_PLAN}`;
  const queryClient = useQueryClient();

  let step = 0;
  let loading = false;
  export let onClose: () => void;

  const buyer = $selectedBuyer;

  $: closeFillColor = step == 0 ? "#FFFFFF99" : "#00000080";

  function handleTrialContinue() {
    initiateSubscription();
    track("signup_intro_screen_2_cta_click");
  }

  async function initiateSubscription() {
    if (!buyer?.id) {
      alert("Error: missing buyer id");
      return;
    }
    loading = true;

    try {
      const response = await createSubscription({
        buyer_ids: [buyer.id],
        plan: DEFAULT_PLAN,
        return_url: DEFAULT_RETURN_URL,
      });

      if (response.payment_link) {
        track("signup_stripe_subscription_form_open", {
          plan: DEFAULT_PLAN,
          subscription_id: response.subscription_id,
        });
        await queryClient.invalidateQueries({
          queryKey: subscriptionKeys.byBuyerID(buyer.id),
          refetchType: "all",
        });
        window.location.assign(response.payment_link);
      }
    } catch (error) {
      console.error(error);
      track("signup_stripe_subscription_error_bkd");
    } finally {
      loading = false;
    }
  }

  $: switch (step) {
    case 0:
      track("signup_intro_screen_1_view");
      break;
    case 1:
      track("signup_intro_screen_2_view");
      break;
  }

  function handleIntroContinue() {
    step = 1;
    track("signup_intro_screen_1_cta_click");
  }
</script>

<div class="container">
  <button class="close" on:click={onClose}><CloseIcon fill={closeFillColor} /></button>
  {#if step === 0}
    <Intro onContinue={handleIntroContinue} />
  {:else if step === 1}
    <div class="step" in:fly|global={{ x: 400, duration: 200 }}>
      <Trial onContinue={handleTrialContinue} {loading} />
    </div>
  {/if}
</div>

<style>
  .container {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    background-color: #ffffff;
    border-radius: 24px;
    position: relative;
    overflow: hidden;
    height: 75%;
    max-width: 944px;
    max-height: 600px;
    transition: all 0.3s ease;
  }

  .close {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  .step {
    display: flex;
    flex: 1;
  }
</style>
